import { useEffect, useState } from "react";
import Slider from "../components/Slider";
import { getAuth } from "firebase/auth";
import { useIntl } from "react-intl";
import UserSmallTile from "../components/UserSmallTile";
import { UserType } from "../utils/types";
import { fetchUser } from "./ProfileUtil";
import { fetchUsers } from "./HomeUtil";
import { Button, Text, Select, ActionIcon, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { toast } from "react-toastify";
import { countries } from "../utils/countries";
import * as lists from "../utils/listValues";

export default function Home() {
  const auth = getAuth();
  const intl = useIntl();
  const [loggedinUser, setLoggedinUser] = useState<UserType | null>(null);
  const [users, setUsers] = useState<UserType[]>([]);
  const [showMoreOfferings, setShowMoreOfferings] = useState(false);
  const [showMoreLooking, setShowMoreLooking] = useState(false);

  const [usersOfferingJobFiltered, setUsersOfferingJobFiltered] = useState<
    UserType[]
  >([]);
  const [usersLookingJobFiltered, setUsersLookingJobFiltered] = useState<
    UserType[]
  >([]);

  const [profAreaOffering, setProfAreaOffering] = useState<string | null>(null);
  const [countryOffering, setCountryOffering] = useState<string | null>(null);
  const [cityOffering, setCityOffering] = useState("");

  const [profAreaLooking, setProfAreaLooking] = useState<string | null>(null);
  const [countryLooking, setCountryLooking] = useState<string | null>(null);
  const [cityLooking, setCityLooking] = useState("");

  const loggedInUserConnections = loggedinUser?.connections
    ? loggedinUser?.connections
    : [];
  const usersWithMessages = users.filter((x) => x.unreadMessages);

  const usersOfferingJob = users.filter(
    (x) =>
      !x.unreadMessages &&
      x.reason === "offering" &&
      x.id !== process.env.REACT_APP_SR_USER_ID
  );

  const usersLookingForJob = users.filter(
    (x) =>
      !x.unreadMessages &&
      x.reason === "looking" &&
      x.id !== process.env.REACT_APP_SR_USER_ID
  );

  useEffect(() => {
    if (auth.currentUser?.uid) {
      fetchUser(auth.currentUser?.uid, setLoggedinUser);
    }
  }, [auth.currentUser?.uid]);

  useEffect(() => {
    fetchUsers(setUsers);
  }, []);

  useEffect(() => {
    const filtered = users.filter(
      (x) =>
        !x.unreadMessages &&
        x.reason === "offering" &&
        x.id !== process.env.REACT_APP_SR_USER_ID
    );

    setUsersOfferingJobFiltered(
      showMoreOfferings ? filtered : filtered.slice(0, 3)
    );
  }, [users, showMoreOfferings]);

  useEffect(() => {
    const filtered = users.filter(
      (x) =>
        !x.unreadMessages &&
        x.reason === "looking" &&
        x.id !== process.env.REACT_APP_SR_USER_ID
    );

    setUsersLookingJobFiltered(
      showMoreLooking ? filtered : filtered.slice(0, 3)
    );
  }, [users, showMoreLooking]);

  const handleOfferingMoreButtonClick = () => {
    if (!auth.currentUser) {
      toast.info("Please sign in to view more users");
      return;
    }

    setShowMoreOfferings((prev) => {
      const newState = !prev;
      // re-trigger filtering using current filters
      const filtered = users.filter(
        (x) =>
          !x.unreadMessages &&
          x.reason === "offering" &&
          x.id !== process.env.REACT_APP_SR_USER_ID &&
          (!profAreaOffering || x.profArea === profAreaOffering) &&
          (!countryOffering || x.country === countryOffering) &&
          (!cityOffering ||
            x.city?.toLowerCase().includes(cityOffering.toLowerCase()))
      );

      setUsersOfferingJobFiltered(newState ? filtered : filtered.slice(0, 3));
      return newState;
    });
  };

  const handleLookingMoreButtonClick = () => {
    if (!auth.currentUser) {
      toast.info("Please sign in to view more users");
      return;
    }

    setShowMoreLooking((prev) => {
      const newState = !prev;
      // re-trigger filtering using current filters
      const filtered = users.filter(
        (x) =>
          !x.unreadMessages &&
          x.reason === "looking" &&
          x.id !== process.env.REACT_APP_SR_USER_ID &&
          (!profAreaLooking || x.profArea === profAreaLooking) &&
          (!countryLooking || x.country === countryLooking) &&
          (!cityLooking ||
            x.city?.toLowerCase().includes(cityLooking.toLowerCase()))
      );

      setUsersLookingJobFiltered(newState ? filtered : filtered.slice(0, 3));
      return newState;
    });
  };

  const onProfAreaOfferingChange = (value: string | null) => {
    //if (!value) return;
    //console.log(value);
    setProfAreaOffering(value);
  };

  const onCountryOfferingChange = (value: string | null) => {
    //if (!value) return;
    //console.log(value);
    setCountryOffering(value);
  };

  const onCityOfferingBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const newCityValue = event.target.value;
    //console.log(newCityValue);
    setCityOffering(newCityValue);
  };

  const onSearchOfferingButtonClick = () => {
    const filtered = users.filter(
      (x) =>
        !x.unreadMessages &&
        x.reason === "offering" &&
        x.id !== process.env.REACT_APP_SR_USER_ID &&
        (!profAreaOffering || x.profArea === profAreaOffering) &&
        (!countryOffering || x.country === countryOffering) &&
        (!cityOffering ||
          x.city?.toLowerCase().includes(cityOffering.toLowerCase()))
    );

    setUsersOfferingJobFiltered(
      //showMoreOfferings ? filtered : filtered.slice(0, 3)
      filtered
    );
  };

  const onProfAreaLookingChange = (value: string | null) => {
    //if (!value) return;
    //console.log(value);
    setProfAreaLooking(value);
  };

  const onCountryLookingChange = (value: string | null) => {
    //if (!value) return;
    //console.log(value);
    setCountryLooking(value);
  };

  const onCityLookingBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const newCityValue = event.target.value;
    //console.log(newCityValue);
    setCityLooking(newCityValue);
  };

  const onSearchLookingButtonClick = () => {
    const filtered = users.filter(
      (x) =>
        !x.unreadMessages &&
        x.reason === "looking" &&
        x.id !== process.env.REACT_APP_SR_USER_ID &&
        (!profAreaLooking || x.profArea === profAreaLooking) &&
        (!countryLooking || x.country === countryLooking) &&
        (!cityLooking ||
          x.city?.toLowerCase().includes(cityLooking.toLowerCase()))
    );

    setUsersLookingJobFiltered(
      //showMoreLookings ? filtered : filtered.slice(0, 3)
      filtered
    );
  };

  return (
    <div className="home-page">
      <Slider />
      <div className="home-content">
        {usersWithMessages.length > 0 && (
          <div className="home-grid">
            <h2 style={{ fontSize: "1.125rem" }}>
              {intl.formatMessage({
                id: "home.newMessages",
                defaultMessage: "New messages and recent updates",
              })}
            </h2>
            <div className="home-grid-users">
              {usersWithMessages.map((user) => (
                <div className="home-grid-user" key={user.id}>
                  <UserSmallTile
                    key={user.id}
                    user={user}
                    loggedinUserConnections={loggedInUserConnections}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
        {usersOfferingJob.length > 0 && (
          <div className="home-grid">
            <div className="home-grid-header">
              <h2 className="home-grid-header-title">
                {intl.formatMessage({
                  id: "home.offeringJob",
                  defaultMessage:
                    "Explore current job opportunities, including part-time and contract jobs",
                })}
              </h2>
              {showMoreOfferings && (
                <div className="home-grid-search">
                  <Select
                    id="prof-area"
                    mt="sm"
                    //  label={intl.formatMessage({ id: "home.profArea" })}
                    data={lists.professionalAreasOptions.map((option) => ({
                      value: option.value,
                      label: intl.formatMessage({
                        id: `lookup.profArea.${option.value}`,
                      }),
                    }))}
                    checkIconPosition="right"
                    value={profAreaOffering}
                    onChange={onProfAreaOfferingChange}
                    searchable
                    clearable
                    placeholder={intl.formatMessage({ id: "home.profArea" })}
                    style={{ width: "15rem" }}
                  ></Select>
                  <Select
                    id="prof-area"
                    mt="sm"
                    //  label={intl.formatMessage({ id: "profile.country" })}
                    data={countries.map((area) => ({
                      value: area.code,
                      label: area.name,
                    }))}
                    checkIconPosition="right"
                    value={countryOffering}
                    onChange={onCountryOfferingChange}
                    searchable
                    clearable
                    placeholder={intl.formatMessage({ id: "profile.country" })}
                    style={{ width: "15rem" }}
                  ></Select>
                  <div className="home-grid-search-input">
                    <TextInput
                      id="city"
                      mt="sm"
                      //   label={intl.formatMessage({ id: "profile.city" })}
                      placeholder={intl.formatMessage({ id: "profile.city" })}
                      inputWrapperOrder={["label", "input"]}
                      value={cityOffering}
                      onChange={(e) => setCityOffering(e.currentTarget.value)}
                      onBlur={onCityOfferingBlur}
                    />
                    <ActionIcon
                      variant="filled"
                      color="#0abab5"
                      size="lg"
                      radius="md"
                      aria-label="Search"
                      onClick={onSearchOfferingButtonClick}
                    >
                      <IconSearch size={20} />
                    </ActionIcon>
                  </div>
                </div>
              )}
            </div>
            <div className="home-grid-users">
              {usersOfferingJobFiltered.length > 0 ? (
                usersOfferingJobFiltered.map((user) => (
                  <div className="home-grid-user" key={user.id}>
                    <UserSmallTile
                      key={user.id}
                      user={user}
                      loggedinUserConnections={loggedInUserConnections}
                    />
                  </div>
                ))
              ) : (
                <Text c="dimmed" mt="md" ta="center">
                  {intl.formatMessage({
                    id: "home.noMatches",
                  })}
                </Text>
              )}
            </div>
            {usersOfferingJob.length > 3 && (
              <div className="home-more-button-container">
                <Button
                  className="home-more-button"
                  onClick={handleOfferingMoreButtonClick}
                >
                  {showMoreOfferings
                    ? intl.formatMessage({ id: "home.less" })
                    : intl.formatMessage({ id: "home.more" })}
                </Button>
              </div>
            )}
          </div>
        )}
        {usersLookingForJob.length > 0 && (
          <div className="home-grid">
            <div className="home-grid-header">
              <h2 className="home-grid-header-title">
                {intl.formatMessage({
                  id: "home.lookingForJob",
                  defaultMessage:
                    "Find professionals currently seeking part-time and contract jobs",
                })}
              </h2>
              {showMoreLooking && (
                <div className="home-grid-search">
                  <Select
                    id="prof-area"
                    mt="sm"
                    // label={intl.formatMessage({ id: "home.profArea" })}
                    data={lists.professionalAreasOptions.map((option) => ({
                      value: option.value,
                      label: intl.formatMessage({
                        id: `lookup.profArea.${option.value}`,
                      }),
                    }))}
                    checkIconPosition="right"
                    value={profAreaLooking}
                    onChange={onProfAreaLookingChange}
                    searchable
                    clearable
                    placeholder={intl.formatMessage({ id: "home.profArea" })}
                    style={{ width: "15rem" }}
                  ></Select>
                  <Select
                    id="prof-area"
                    mt="sm"
                    // label={intl.formatMessage({ id: "profile.country" })}
                    data={countries.map((area) => ({
                      value: area.code,
                      label: area.name,
                    }))}
                    checkIconPosition="right"
                    value={countryLooking}
                    onChange={onCountryLookingChange}
                    searchable
                    clearable
                    placeholder={intl.formatMessage({ id: "profile.country" })}
                    style={{ width: "15rem" }}
                  ></Select>
                  <TextInput
                    id="city"
                    mt="sm"
                    // label={intl.formatMessage({ id: "profile.city" })}
                    placeholder={intl.formatMessage({ id: "profile.city" })}
                    inputWrapperOrder={["label", "input"]}
                    value={cityLooking}
                    onChange={(e) => setCityLooking(e.currentTarget.value)}
                    onBlur={onCityLookingBlur}
                  />
                  <ActionIcon
                    variant="filled"
                    color="#0abab5"
                    size="lg"
                    radius="md"
                    aria-label="Search"
                    onClick={onSearchLookingButtonClick}
                  >
                    <IconSearch size={20} />
                  </ActionIcon>
                </div>
              )}
            </div>
            <div className="home-grid-users">
              {usersLookingJobFiltered.length > 0 ? (
                usersLookingJobFiltered.map((user) => (
                  <div className="home-grid-user" key={user.id}>
                    <UserSmallTile
                      key={user.id}
                      user={user}
                      loggedinUserConnections={loggedInUserConnections}
                    />
                  </div>
                ))
              ) : (
                <Text c="dimmed" mt="md" ta="center">
                  {intl.formatMessage({
                    id: "home.noMatches",
                  })}
                </Text>
              )}
            </div>
            {usersLookingForJob.length > 3 && (
              <div className="home-more-button-container">
                <Button
                  className="home-more-button"
                  onClick={handleLookingMoreButtonClick}
                  //disabled={!auth.currentUser}
                >
                  {showMoreLooking
                    ? intl.formatMessage({ id: "home.less" })
                    : intl.formatMessage({ id: "home.more" })}
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
